<style lang="scss">
.zoezi-bottombar {
    z-index: 6;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 56px;
    display: flex;
    width: 100%;
    max-width: 100%;
}
</style>

<template>
    <div
        class="zoezi-bottombar"
        :style="{'background-color': $root.colorToHex(backgroundColor)}"
    >
        <component-wrapper
            v-for="config in buttons"
            :key="config.id"
            :config="config"
            :style="{width: 100/(buttons.length+1) + '%' }"
        />

        <component-wrapper
            :config="menuButton"
            :style="{width: 100/(buttons.length+1) + '%' }"
        />
    </div>
</template>

<script>
import components from '../component.js'
import Vue from 'vue'
export default {
    name: 'zoezi-bottombar',

    zoezi: {
        title: 'Bottom row',
        icon: 'mdi-dock-bottom'
    },

    props: {
        buttonsNotLoggedIn: {
            title: 'Buttons - logged out',
            type: Array,
            fulltype: 'componentlist',
            default: () => [
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'Join', icon: 'mdi-card-account-details-star-outline'}}),
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'Book', icon: 'mdi-home-outline'}}),
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'SHOP_VERB', icon: 'mdi-cart-outline'}}),
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'Log in', icon: 'mdi-account-lock-outline'}})
            ],
            typeinfo: {
                component: 'zoezi-bottom-bar-button',
                max: 4
            }
        },
        buttonsLoggedIn: {
            title: 'Buttons - logged in',
            type: Array,
            fulltype: 'componentlist',
            default: () => [
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'Workouts', icon: 'mdi-card-account-details-star-outline'}}),
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'Discover', icon: 'mdi-home-outline'}}),
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'SHOP_VERB', icon: 'mdi-cart-outline'}}),
                components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'My page', icon: 'mdi-account-details-outline'}})
            ],
            typeinfo: {
                component: 'zoezi-bottom-bar-button',
                max: 4
            }
        },
        menuButton: {
            title: 'Menu button',
            type: Object,
            fulltype: 'component',
            typeinfo: {
                component: 'zoezi-bottom-bar-button'
            },
            default: () => components.makeEmptyConfig({component: 'zoezi-bottom-bar-button', props: {title: 'More', icon: 'mdi-dots-horizontal-circle-outline', openMobileMenu: true}})

        },
        backgroundColor: {
            title: 'Background color',
            type: String,
            fulltype: 'color',
            default: '#ffffff'
        }
    },

    watch: {
        '$vuetify.breakpoint.width': {
            immediate: true,
            handler() {
                Vue.nextTick(() => {
                    let width = this.$refs.r ? this.$refs.c.clientWidth : 0;
                    this.width = width
                });
            }
        }
    },

    computed: {
        buttons() {
            return this.$store.state.isLoggedIn ? this.buttonsLoggedIn : this.buttonsNotLoggedIn;
        }
    },

    data: () => ({
    })
}
</script>
